
import "../css/platform.css";

import "../css/general.css";
import "../css/Subject.css"; // Imports like this require WebPack! (create-react-app uses WebPack)
// TODO ^^^^^^^^^^^^^^^^^^^^^^ - Move out the "Course" part to "Course.css" ????
//               OR NAHHHHH  -- Since this is Program.tsx w/ all related mushed in...
//              ... Or should even this be separated out a bit more -- PROBABLY...

import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import htmlParser from "html-react-parser";

import { fromKebabCaseToCamelCase, toCamelCase, toKebabCase } from "../utilities/helpers";
import { fetchVideoURL } from "../utilities/server-fetch";


import { Header } from "./../common/Header";
import VideoPlayer from "./../common/VideoPlayer";
import { HamburgerMenu, Checkmark, FeatureComingSoon, LockIcon, LogInPromptContainer } from "../common/Components";

import { SubjectSelector, SubjectTypeSelector, ProgramSelector, FeatureTypeSelector, Color, TextColor, BackgroundColor } from "@Beasted1010/pivotal-wisdom";

import { useUser, useUserUpdate } from "../context/UserContext";
import { ProgramContextProvider } from "../context/ProgramContext";
import { useProgram, useProgramUpdate } from "../context/ProgramContext";

import { useCourse, useCourseUpdate } from "../context/CourseContext";
import { useDeepDives, useDeepDivesUpdate } from "../context/DeepDivesContext";
import { useLessons, useLessonsUpdate } from "../context/LessonsContext";

//import { SubjectsMetadataContextProvider, useSubjectsMetadata } from "../context/SubjectsMetadataContext";
import { SubjectContextProvider, useSubject, useSubjectUpdate } from "../context/SubjectContext";


export { Subject };



type SubjectParams = {
  type: SubjectTypeSelector;
  subjectSelector: SubjectSelector;
  programSelector: ProgramSelector;
  //featureSelector: FeatureTypeSelector;
}


function Subject() {

  //const { type: subjectType, subjectSelector, programSelector } = useParams<SubjectParams>();
  //if( subjectType == null || subjectSelector == null || programSelector == null ) return <></>;

  const params = useParams<SubjectParams>();
  if( params.type == null || params.subjectSelector == null || params.programSelector == null ) return <></>;

  const subjectType = fromKebabCaseToCamelCase( params.type ) as SubjectTypeSelector;
  const subjectSelector = fromKebabCaseToCamelCase( params.subjectSelector ) as SubjectSelector;
  const programSelector = fromKebabCaseToCamelCase( params.programSelector ) as ProgramSelector;

  return (
    <>
      <SubjectContextProvider subjectType={subjectType} subjectSelector={subjectSelector} programSelector={programSelector}>
        {/* TODO: Consider independent-izing Header cuz ProgramContext now wraps RibbonCntext per React Profiler ... BUT need Program Name and Program Heading some way...*/}
        <Header content={<HeaderContent />} />

        <Main />
      </SubjectContextProvider>
    </>
  );
}


function HeaderContent() {
  // TODO: Enforce Structure -- Need Generics on useProgram in ProgramContext.tsx... useProgram has more than just programData
  //const { programData } = useProgram<IProgram>();
  const { subjectData } = useSubject();

  // TODO: Think if properly understand/work-with Component Life Cycle, this wouldn't be a problem, i.e. avoid Rendering this until after Context fully ran ("useEffect" ran)
  //         MINIMIZE RENDERS -- Cache, Intelligent Rendering, etc.
  //      -- APPLIES TO ALL "== null" Checks when accessing Context Data
  if( subjectData == null ) return <></>;

  const subjectName = subjectData.name;
  //const programHeading = subjectData.heading;

  // TODO: ERROR HANDLE when not programName or not programHeading (e.g. NULL) -- Enforce via TYPEs

  return (
    <div className="platform_page_header_container">
      <div className="platform_page_header_content">
        <h1 className="platform_page_header_heading">{subjectName} Programs</h1>
        <p className="platform_page_header_slogan">
          {/*{htmlParser( programHeading )}*/}
        </p>
      </div>
    </div>
  );
}


function Main() {

  const { subjectData, programData } = useSubject();
  if( !subjectData || !programData ) return <></>; // TODO: ERROR HANDLE / "LOADING" indicator ??

  return (
    <main className="platform_body subject_body">

      <Programs />

      <Features />

    </main>
  );
}


/* =========================== Programs =========================== */
function Programs() {
  const { subjectData, programData, selectedProgram } = useSubject();
  const { selectProgram } = useSubjectUpdate();

  const [ isOpen, setIsOpen ] = useState( false );
  const toggleDropDown = () => setIsOpen( !isOpen );
  const closeDropDown = () => setIsOpen( false );

  return (
    <>
      <div className="subject_body_programs_container">
        <h2 className="subject_body_program_selection-notice">
          <span className={`subject_body_program_selection-notice_name ${TextColor[programData.color as Color]}`}>{programData.name}</span> Content
        </h2>

        <div className="subject_body_program_card_container">
          {subjectData?.programs.map( (program: IProgram, index: number) => {
            const isSelected = program.selector === selectedProgram;
            return <ProgramCard programName={program.name} programSelector={program.selector} isSelected={isSelected} color={program.color} key={program.selector} />
          })}
        </div>
      </div>

      <div className="subject_body_programs_dropdown_container">
        <button type="button" onClick={() => toggleDropDown()} className="subject_body_programs_dropdown">
          {programData.name}
          <ul className={`subject_body_programs_dropdown_list ${isOpen ? "subject_body_programs_dropdown_list_open" : ""}`}>
            {subjectData?.programs.map( (program: IProgram, index: number) => {
              const isSelected = program.selector === selectedProgram;

              return (
                <li className={`${isSelected ? `subject_body_programs_dropdown_list_selection` : ""}`} onClick={() => selectProgram(program.selector)} key={program.selector} >
                  {program.name}
                </li>
              )
            })}
          </ul>
        </button>
      </div>
    </>
  );

  /*
    <li onClick={() => selectLesson(number) }
        value={number}
        onMouseEnter={ () => setIsHovered(true) }
        onMouseLeave={ () => setIsHovered(false) }
        title={name}
        className={`program_body_overview_course_lesson
                    ${ isHovered ? TextColor[color] : ''}
                    ${ isSelected ? `lesson_selected ${TextColor[color]}` : "" }`}></li>
                    */

}

function ProgramCard( {programName, programSelector, isSelected, color}: any ) {
  const { selectProgram } = useSubjectUpdate();

  return (
    <button type="button" 
            className={`subject_body_program_card ${isSelected ? `subject_body_program_card_selected ${BackgroundColor[color as Color]}` : ""}`}
            onClick={() => selectProgram(programSelector)}>

      <span className="subject_body_program_card_name">{programName}</span>
    </button>
  );
}




/* =========================== Features =========================== */
function Features() {
  const { programData } = useSubject();

  return (
    <section className="subject_body_features_container">

      {programData?.features.map( (feature: IFeature, index: number) => {
        return <FeatureCard featureName={feature.type} featureSelector={feature.selector} featureDetails={"BLAH BLAH"} key={feature.selector} />
      })}
      <div className=""></div>
      
    </section>
  );
}

function FeatureCard( {featureName, featureSelector, featureDetails}: any ) {
  const navigate = useNavigate();

  const { selectedSubjectType, selectedSubject, selectedProgram } = useSubject();

  const goToFeature = (selectedFeature: string) => {
    // TODO: Currently just blindly adding toKebabCase to get consistency with URL -- Consider more efficient way to handle this or at least place earlier to have variable itself already be in Kebab Case
    navigate( `/content/${toKebabCase(selectedSubjectType)}/${toKebabCase(selectedSubject)}/${toKebabCase(selectedProgram)}/${toKebabCase(selectedFeature)}` );
  }

  return (
    <a className="subject_body_feature_card_container" onClick={() => goToFeature(featureSelector)}>
      <div className="subject_body_feature_card">
        {/*<h2 className="subject_body_feature_card_name">{featureName}</h2>*/}
        <h3 className="subject_body_feature_card_name">{featureName}</h3>
        <p className="subject_body_feature_card_details">{featureDetails}</p>
      </div>
    </a>
  );
}





















/* =========================== Overview =========================== */
function Overview() {
  return (
    <div className="program_body_overview">
      <div className="">THING Content</div>
      <Subjects />

      {/*<Programs />*/}
    </div>
  );
}

function Subjects() {
  // TODO: Enforce Structure ... via <Generics>
  const { programData, selectedFeature } = useSubject();
  const { selectFeature } = useProgramUpdate();

  return (
    <div className="program_body_overview_nav">

      <select onChange={(e) => selectFeature(e.target.value)} value={selectedFeature} className="program_body_overview_nav_drop-down">
        {programData.features.map( (featureMetadata: IFeature, index: number) => {
          return <NavigationOption name={featureMetadata.type} selector={featureMetadata.selector} key={featureMetadata.selector} />
        })}

        <option value="MoreToCome" disabled>... More to Come! ...</option>
      </select>
    </div>
  );
}

type NavigationProps = {
  name: string;
  selector: FeatureTypeSelector;
}
function NavigationOption( {name, selector}: NavigationProps ) {
  return (
    <option value={selector} className="program_body_overview_nav_drop-down_option">
      {name}
    </option>
  );
}

function ContentOverviewFreeText( {text="FREE"}: {text?: string} ) {
  return (
    <span className="content-overview-free-text">{text}</span>
  )
}




/* =========================== Feature =========================== */

function FeatureOverview() {

  const { selectedFeature } = useProgram(); // TODO: TYPE-IT
  if( selectedFeature == null ) return <></>; // TODO: Proper Error Handle ??

  return (
    <>
      {renderFeatureSwitch(selectedFeature, FeatureAspect.OVERVIEW)}
    </>
  )
}

function Feature() {
  const { selectedFeature } = useProgram(); // TODO: TYPE-IT
  if( selectedFeature == null ) return <></>; // TODO: Proper Error Handle ??

  return (
    <>
      {renderFeatureSwitch(selectedFeature, FeatureAspect.CONTENT)}
    </>
  );
}



enum FeatureAspect {
  OVERVIEW = "overview",
  CONTENT = "content",
}
function renderFeatureSwitch( selectedFeature: FeatureTypeSelector, featureAspect: FeatureAspect ) {
  switch( toCamelCase(selectedFeature) ) {
    case FeatureTypeSelector.COURSE:
      return featureAspect == FeatureAspect.OVERVIEW ? <CourseOverview /> : <CourseContent />;
      break;

    case FeatureTypeSelector.DEEP_DIVES:
      return featureAspect == FeatureAspect.OVERVIEW ? <DeepDivesOverview /> : <DeepDivesContent />;
      break;

    case FeatureTypeSelector.QUIZZES:
      return featureAspect == FeatureAspect.OVERVIEW ? <QuizzesOverview /> : <QuizzesContent />;
      break;

    case FeatureTypeSelector.ACTION_PLAN:
      return featureAspect == FeatureAspect.OVERVIEW ? <ActionPlanOverview /> : <ActionPlanContent />;
      break;

    case FeatureTypeSelector.RESOURCES:
      return featureAspect == FeatureAspect.OVERVIEW ? <ResourcesOverview /> : <ResourcesContent />;
      break;

    case FeatureTypeSelector.COACHING:
      return featureAspect == FeatureAspect.OVERVIEW ? <CoachingOverview /> : <CoachingContent />;
      break;

    default:
      console.error("INVALID FEATURE SELECTED -- ", selectedFeature); // TODO: ERROR HANDLE
      break;
  }
}




/* ======================================================================= */
/* =============================== Course ================================ */
/* ======================================================================= */


/* =========================== Course Overview =========================== */
function CourseOverview() {
  return (
    <LessonsOverview />
  );
}


/* =========================== Course Content =========================== */

function CourseContent() {
  return (
    <LessonContent />
  );
}





/* ======================================================================= */
/* =============================== Deep Dives ================================ */
/* ======================================================================= */


/* =========================== Deep Dives Overview =========================== */
function DeepDivesOverview() {
  return (
    <LessonsOverview />
  );
}

/* =========================== Deep Dives Content =========================== */
function DeepDivesContent() {
  return (
    <LessonContent />
  );
}



/* ======================================================================= */
/* =============================== Quizzes ================================ */
/* ======================================================================= */


/* =========================== Action Plan Overview =========================== */
function QuizzesOverview() {
  return (
    <div>
      <FeatureComingSoon />
    </div>
  );
}

/* =========================== Action Plan Content =========================== */
function QuizzesContent() {
  return (
    <div className="program_body_quizzes-content">
      <FeatureComingSoon />
    </div>
  );
}


/* ======================================================================= */
/* =============================== Action Plan ================================ */
/* ======================================================================= */


/* =========================== Action Plan Overview =========================== */
function ActionPlanOverview() {
  return (
    <div>
      <FeatureComingSoon />
    </div>
  );
}

/* =========================== Action Plan Content =========================== */
function ActionPlanContent() {
  return (
    <div className="program_body_action-plan-content">
      <FeatureComingSoon />
    </div>
  );
}





/* ======================================================================= */
/* =============================== Resources ================================ */
/* ======================================================================= */


/* =========================== Resources Overview =========================== */
function ResourcesOverview() {
  return (
    <div>
      <FeatureComingSoon />
    </div>
  );
}

/* =========================== Resources Content =========================== */
function ResourcesContent() {
  return (
    <div className="program_body_resource-content">
      <FeatureComingSoon />
    </div>
  );
}





/* ======================================================================= */
/* =============================== Coaching ================================ */
/* ======================================================================= */


/* =========================== Coaching Overview =========================== */
function CoachingOverview() {
  return (
    <div>
      <FeatureComingSoon />
    </div>
  );
}

/* =========================== Coaching Content =========================== */
function CoachingContent() {
  return (
    <div className="program_body_coaching-content">
      <FeatureComingSoon />
    </div>
  );
}







/* =============================== GENERAL ================================ */
/* ======================================================================= */

/* =============================== Lessons ================================ */
/* ======================================================================= */


/* =========================== Course Overview =========================== */
function LessonsOverview() {
  return (
    <>
      <LessonsProgress />
      <hr/>
      <Lessons />
    </>
  );
}


function LessonsProgress() {

  // TODO: ALL BELOW CODE B4 RETURN IS REUSED FOR PERCENTAGE ABOVE -- Function?
  const { lessonsData } = useLessons();
  if( lessonsData == null ) return <></>; // TODO: ERROR HANDLE

  const { numberOfLessons, completedLessonsCount } = getLessonsCompletionData( lessonsData );
  const percentComplete = (completedLessonsCount / numberOfLessons) * 100;

  return (
    <div className="program_body_overview_progress">
      <h3 className="program_body_overview_progress_title">Progress</h3>
      <div className="program_body_overview_progress_pie">{percentComplete}%</div>
    </div>
  );
}

function Lessons() {
  const { user } = useUser();
  const isAuthorized = user != null ? true : false; // TODO: Simple "Log In to View" Functionality for now (LATER will implement "purchase to veiw")

  const { lessonsData, selectedLesson } = useLessons();
  if( lessonsData == null ) return <></>; // TODO: ERROR HANDLE

  // TODO: This currently re-renders ALL Lessons each time Hover over new Lesson
  return (
    <div className="program_body_overview_course_lessons">
      <LessonsHeader />

      <ol className="program_body_overview_course_lessons_list">
        {lessonsData.map( (lesson: ILesson, index: number) => {
          return <Lesson isFree={lesson.free} isAuthorized={isAuthorized} number={lesson.number} name={lesson.name} isComplete={lesson.complete} isSelected={lesson.number == selectedLesson.number} key={lesson.name+String(lesson.complete)} />
        })}
      </ol>
    </div>
  );
}

function LessonsHeader() {
  const { lessonsData } = useLessons();
  if( lessonsData == null ) return <></>; // TODO: ERROR HANDLE

  const { numberOfLessons, completedLessonsCount } = getLessonsCompletionData( lessonsData );

  return (
    <div className="program_body_overview_course_lessons_header">
      <h3 className="program_body_overview_course_lessons_header_title">Lessons</h3>
      <h4 className="program_body_overview_course_lessons_header_progress">{completedLessonsCount} / {numberOfLessons}</h4>
    </div>
  );
}

function Lesson( {isFree, isAuthorized, number, name, isComplete, isSelected}: any ) {
  const { selectLesson } = useLessonsUpdate();
  const { programData } = useProgram();

  const [ isHovered, setIsHovered ] = useState<boolean>( false );

  const color: Color = programData.color;

  const setLessonHovered = (mouseInside: boolean) => setIsHovered( mouseInside );

  // TODO: Add special styles for the selected Lesson (make visually obvious)
  return (
    <li onClick={() => selectLesson(number) }
        value={number}
        onMouseEnter={ () => setIsHovered(true) }
        onMouseLeave={ () => setIsHovered(false) }
        title={name}
        className={`program_body_overview_course_lesson
                    ${ isHovered ? TextColor[color] : ''}
                    ${ isSelected ? `lesson_selected ${TextColor[color]}` : "" }`}>
      {name}

      {/*TODO: Shouldn't even have "isComplete" be true if user not logged in... So why it true if user not logged in?*/}
      { isComplete && isAuthorized ? <Checkmark color={ color } key={isComplete} /> 
                   : (isFree || isAuthorized ? (isFree && !isAuthorized ? <ContentOverviewFreeText /> : <></>)
                             : <LockIcon size="16" cssClassName="content-overview_lock-icon"  key={isFree}/>) }
    </li>
  );
}




/* =========================== Course Content =========================== */

function LessonContent() {
  const { selectedLesson } = useLessons();

  const { user } = useUser();
  const isAuthorized = user != null ? true : false; // TODO: Simple "Log In to View" Functionality for now (LATER will implement "purchase to veiw")

  if( selectedLesson == null ) return <></>; // TODO: Proper Error Handle


  return (
    <div className="program_body_course-content">
      <LessonContentHeader />

      {
        selectedLesson.free || isAuthorized ?
          (
            <>
              <LessonIntro />

              <LessonVideo />

              <LessonKeyPoints />
            </>
          ) : 
            <div className="locked-content">
              <LogInPromptContainer HeaderComponent={LockIcon} logInTo="access" description="This content is locked." />
            </div>
      }
            {/*<div style={{display: "flex", justifyContent: "center"}}>*/}
    </div>
  );
}


function LessonContentHeader() { // NOTE: Will move to own file, so no naming Conflicts w/ other Features
  const { selectedLesson } = useLessons(); // TODO: TYPE-IT -- Make "useCourse()" instead?
  if( selectedLesson == null ) return <></>; // TODO: Proper Error Handle ??

  const lessonNumber = selectedLesson.number;
  const lessonName = selectedLesson.name;
  const lessonTimeTake = selectedLesson.timeTake;

  const lessonTitleText = `${lessonNumber}. ${lessonName}`;
  const lessonTimeTakeText = lessonTimeTake ? `${lessonTimeTake} Minutes` : "";

  return (
    <div className="program_body_course-content_header">
      <h2 className="program_body_course-content_header_title">{lessonTitleText}</h2>
      <h4 className="program_body_course-content_header_time-take">{lessonTimeTakeText}</h4>
    </div>
  );
}

function LessonIntro() {
  const { selectedLesson } = useLessons(); // TODO: TYPE-IT -- Make "useCourse()" instead?
  if( selectedLesson == null ) return <></>; // TODO: Proper Error Handle ??

  const intro = selectedLesson.intro;

  if( !intro ) return <></>;

  return (
    <div className="program_body_course-content_intro">
      <p className="program_body_course-content_intro_text">
        {htmlParser( intro )}
      </p>
    </div>
  );
}

function LessonVideo() {
  const { programData } = useProgram();
  const color: Color = programData.color;

  const { selectedLesson } = useLessons(); // TODO: TYPE-IT -- Make "useCourse()" instead?
  if( selectedLesson == null ) return <></>; // TODO: Proper Error Handle ??


  return (
    <div className="program_body_course-content_video_container">
      <div className="program_body_course-content_video">
        <VideoPlayer videoURL={selectedLesson.videoURL} />
      </div>

      <div className="program_body_course-content_video_buttons_container">
        <button className={`program_body_course-content_video_feedback ${BackgroundColor[color]}`}>
          Give Feedback
          <FeatureComingSoon />
        </button>

        {/*<input id="mark-complete_button" type="checkbox" className={`program_body_course-content_video_mark-complete ${BackgroundColor[color]}`} />*/}
        <MarkComplete selectedLesson={selectedLesson} color={color} />
      </div>
    </div>
  );
}

function MarkComplete( { selectedLesson, color }: {selectedLesson: ILesson, color: Color} ) {

  const { toggleLessonComplete } = useLessonsUpdate();
  const markComplete = () => {
    // TODO: NEED SYNC TO SERVER
    toggleLessonComplete( selectedLesson.number );
  }

  const isComplete = selectedLesson.complete;

  return (
    <div className="program_body_course-content_video_mark-complete">
      <input id="mark-complete_button"
             onChange={() => markComplete()}
             checked={ selectedLesson.complete }
             type="checkbox" />
      <label htmlFor="mark-complete_button">Mark Complete</label>

      {/*<div className={`mark-complete_button_checkbox ${BackgroundColor[color]}`}>*/}
      <div className={`mark-complete_button_checkbox`}>
        { isComplete ? <Checkmark color={ color } /> : <></> }
      </div>
    </div>
  );

}


interface LessonKeyPoint {
  title: string;
  details: string;
}
function LessonKeyPoints() {
  const { selectedLesson } = useLessons(); // TODO: Make "useCourse()" instead?
  if( selectedLesson == null ) return <></>; // TODO: Proper Error Handle ??

  const keyPoints = selectedLesson.keyPoints;
  if( keyPoints == null ) return <></>; // TODO: ERROR HANDLE !?????


  return (
    <div className="program_body_course-content_key-points">
      <h3 className="program_body_course-content_key-points_header">Key Points</h3>
      <ul className="program_body_course-content_key-points_list">
        {keyPoints.map( (keyPoint: LessonKeyPoint, index: number) => {
          return <LessonKeyPoint title={keyPoint.title} details={keyPoint.details} key={keyPoint.title} />
        })}
      </ul>
    </div>
  );
}

function LessonKeyPoint( {title, details}: LessonKeyPoint ) {
  return (
    <div className="program_body_course-content_key-point">
      <h4 className="program_body_course-content_key-point_title purple-blue-lb">{title}</h4>
      <p className="program_body_course-content_key-point_details">{htmlParser( details )}</p>
    </div>
  );
}



/* =========================== Course Helpers =========================== */
function calculateCompletedLessonsCount( lessonsData: ILesson[] ) {
  return lessonsData.reduce( (accumulator: number, lesson: ILesson) => {
    return accumulator + (lesson.complete ? 1 : 0);
  }, 0);
}

function getLessonsCompletionData( lessonsData: ILesson[] ) {
  const numberOfLessons = lessonsData.length;
  const completedLessonsCount = calculateCompletedLessonsCount( lessonsData );

  return { numberOfLessons, completedLessonsCount };
}








/* */
